import { m as motion } from "motion/react";
import { useAnimateFadeIn } from "../../../animation/animation";
import { Shortcut, TShortcutProps as TShortcut } from "../../elements/shortcut/shortcut";
import styles from "./shortcut-list-block.module.less";

export type TShortcutListBlockProps = {
  title: string;
  shortcuts: Array<TShortcut>;
  maxItemsPerRowDesktop?: TDesktopItemPerRowSetting;
};

export type TDesktopItemPerRowSetting = "six" | "four";

export const ShortcutListBlock = ({ title, shortcuts, maxItemsPerRowDesktop = "six" }: TShortcutListBlockProps) => {
  const fadeInAnimation = useAnimateFadeIn({ whileInView: true, easing: "easeInOut" });

  return (
    <motion.section {...fadeInAnimation} className={"max-width padded-sides centered space-mb-2xl"}>
      {title && <p className={[styles.title, "body-base bold"].join(" ")}>{title}</p>}
      {shortcuts && (
        <ul className={[styles.list, styles[maxItemsPerRowDesktop]].join(" ")}>
          {shortcuts.map((shortcut, index) => {
            return (
              <li key={index} className={styles.item}>
                <Shortcut {...shortcut} />
              </li>
            );
          })}
        </ul>
      )}
    </motion.section>
  );
};

export default ShortcutListBlock;
